import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb46fde0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading loading--left-column"
}
const _hoisted_2 = { class: "card--dotted" }
const _hoisted_3 = { class: "card--borderless" }
const _hoisted_4 = { class: "card--dotted" }
const _hoisted_5 = { class: "card--dotted" }
const _hoisted_6 = { class: "card--dotted" }
const _hoisted_7 = {
  key: 1,
  class: "loading loading--date-paginator"
}
const _hoisted_8 = { class: "card--dotted" }
const _hoisted_9 = { class: "card--dotted card--date" }
const _hoisted_10 = { class: "card--dotted" }
const _hoisted_11 = {
  key: 2,
  class: "loading loading--huddle-card card--dotted"
}

import Skeleton from 'primevue/skeleton'

interface Props {
    type: 'left-column' | 'date-paginator' | 'huddle-card'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HuddlesLoading',
  props: {
    type: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_ctx.type === 'left-column')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Skeleton), { height: "20px" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Skeleton), { height: "50px" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Skeleton), { height: "156px" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Skeleton), { height: "100px" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Skeleton), { height: "140px" })
        ])
      ]))
    : (_ctx.type === 'date-paginator')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Skeleton), { height: "20px" })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(Skeleton), { height: "20px" })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Skeleton), { height: "20px" })
          ])
        ]))
      : (_ctx.type === 'huddle-card')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (card) => {
              return _createVNode(_unref(Skeleton), {
                key: card,
                height: "80px"
              })
            }), 64))
          ]))
        : _createCommentVNode("", true)
}
}

})